<template>
	<div>
		<div class="d-flex align-items-center justify-content-between mb16">
			<Icon v-if="isMobile" name="arrow-left" class="pointer" @click="close" />
			<h4 class="text-black neue fw-medium mb-0 lh28 pr24 fsp20" :class="{ 'flex-grow-1 text-center': isMobile }">
				{{ $t('views.Echeck.New.1') }}
			</h4>
			<Icon v-if="!isMobile" name="close" class="pointer" @click="close" />
		</div>
		<div class="bg-white rounded12" :class="{ 'p24': !isMobile }">
			<div class="d-flex mb16" :class="isMobile ? 'flex-column gap8' : 'align-items-center gap16'">
				<div class="d-flex align-items-center gap8" :class="{ 'field-label': !isMobile }">
					<span class="fsp14 neue-roman lh20 text-black">{{ $t('views.Echeck.New.3') }}<span class="require"> *</span></span>
					<Popper :hover="true" :maxWidth="200">
						<Icon name="info" class="c16 pointer" />
						<template #content>
							<div class="text-white fsp14">{{ $t('views.Echeck.New.16') }}</div>
						</template>
					</Popper>
				</div>
				<InputSimple
					type="text"
					id="summ"
					:dataValue="data.summ"
					@updateParentState="updateState"
				>
					<span v-if="selectedCurr" class="fsp14 neue fw-medium primary-grey text-nowrap">{{ selectedCurr }}</span>
				</InputSimple>
			</div>
			<div class="d-flex mb16" :class="isMobile ? 'flex-column gap8' : 'align-items-center gap16'">
				<div class="d-flex align-items-center" :class="{ 'field-label': !isMobile }">
					<span class="fsp14 neue-roman lh20 text-black">{{ $t('views.Echeck.New.5') }}<span class="require"> *</span></span>
				</div>
				<InputSimple
					type="text"
					id="count"
					:dataValue="data.count"
					@updateParentState="updateState"
				/>
			</div>
			<div class="d-flex mb16" :class="isMobile ? 'flex-column gap8' : 'align-items-center gap16'">
				<div class="d-flex align-items-center" :class="{ 'field-label': !isMobile }">
					<span class="fsp14 neue-roman lh20 text-black">{{ $t('views.Echeck.New.2') }}<span class="require"> *</span></span>
				</div>
				<SelectSimple
					id="keyt"
					:keyt="true"
					:isSearch="true"
					:searchType="'curr'"
					:dataValue="data.keyt"
					:keywords.sync="keyts"
					@updateParentState="updateState"
				/>
			</div>
			<div class="mb16">
				<label class="fsp14 neue-roman lh20 mb8">{{ $t('views.Echeck.New.4') }}</label>
				<InputSimple
					type="textarea"
					id="comment"
					:dataValue="data.comment"
					@updateParentState="updateState"
				/>
			</div>
			<div class="d-flex gap-2 mt24" :class="{ 'mobile-modal-buttons': isMobile }">
				<Button
					@click="CreateEcheck"
					:name="$t('views.Echeck.New.7')"
					:disabled="!data.keyt || !data.summ || creating"
					:loader="creating"
					class="h48 equal-width"
					type="btn-warning"
				/>
				<Button
					@click="close"
					:name="$t('views.Echeck.New.6')"
					class="h48 equal-width"
					type="btn-outline-grey"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from '@/components/icons/Icon';
import Button from '@/components/service/Button';
import Popper from '@/components/service/Popper';
import SelectSimple from '@/components/service/SelectSimple';
import InputSimple from '@/components/service/InputSimple';

export default {
	components: {
		Icon,
		Button,
		Popper,
		InputSimple,
		SelectSimple,
	},
	props: {
		close: [Function],
	},
	data() {
		return {
			data: {
				keyt: this.$store.state.modal.content?.keyt || false,
				comment: '',
				summ: false,
				count: '1',
			},
			keyts: [],
			creating: false,
		};
	},
	computed: {
		isMobile() {
			return this.$store.state.resize.w <= 768;
		},
		selectedCurr() {
			if (!this.data.keyt || !this.keyts.length) return '';
			const selected = this.keyts.find(k => k.code === this.data.keyt);
			return selected ? selected.curr : '';
		},
		t() {
			let k = this.$store.getters.get_keyts_keywords;
			if (k.length > 0) {
				this.getKeyts(k);
			}
			return k;
		},
	},
	watch: {
		t: {
			handler: function (newData) {
				this.getKeyts(newData);
			},
			deep: true,
		},
	},
	methods: {
		getKeyts(k) {
			this.keyts = k;
		},
		updateState(state) {
			if (state.id === 'count') {
				if (isNaN(state.value)) {
					state.value = 1;
				}
			}
			this.data[state.id] = state.value;
		},
		CreateEcheck() {
			const listCallback = this.$store.state.modal.content?.callback;
			this.$store.dispatch('openModal', {
				action: true,
				type: 'pay_pass',
				content: {
					callback: () => {
						this.creating = true;
						this.axios.post('CreateEcheck', { loader: 'mini', data: this.prepareParams() }).then(res => {
							const onSuccess = (res) => {
								if (listCallback) {
									listCallback();
								}
								// tables — словарь; берём первую таблицу, только успешно выпущенные
								const table = Object.values(res.data.body.tables || {})[0];
								const rows = (table?.colvalues || []).filter(r => r.success);
								this.$store.commit('MODAL', {
									action: true,
									type: 'EcheckResult',
									content: {
										width: 610,
										result_list: rows,
									},
								});
							};
							// result приходит числом 0 при успехе; бизнес-ошибку (result != 0:
							// недостаточно средств и т.п.) показывает глобальный интерсептор
							// lib.res тостом через modal:'answer' — здесь обрабатываем только успех.
							if (String(res.data.body.result) !== '0') {
								return;
							}
							onSuccess(res);
						}).finally(() => {
							this.creating = false;
						});
					},
				},
			});
		},
		prepareParams() {
			let params = {};
			for (let key in this.data) {
				if (this.data[key]) {
					params[key] = this.data[key];
				}
			}
			return params;
		},
	},
};
</script>

<style lang="scss" scoped>
.field-label {
	width: 136px;
	flex-shrink: 0;
}

</style>
